import Box from '@mui/material/Box'
import FormControlLabel from '@mui/material/FormControlLabel'
import Switch from '@mui/material/Switch'
import Typography from '@mui/material/Typography'

import type { AvailableColumn } from '../types'
import * as S from './styles'
import { filterEmptyColumn, isLastEnabledColumn } from './utils'

interface ColumnPickerStaticColumnsProps {
  staticColumns: AvailableColumn[]
  handleToggle: (id: string) => void
  selectedColumns: string[]
}

export const ColumnPickerStaticColumns = ({
  staticColumns,
  handleToggle,
  selectedColumns,
}: ColumnPickerStaticColumnsProps) => (
  <Box data-test-id="static-col-container">
    {staticColumns.filter(filterEmptyColumn).map((column) => (
      <S.StaticColumnRow key={column.id}>
        <FormControlLabel
          control={
            <Switch
              data-test-id={`stat-col-${column.id}`}
              size="small"
              checked={selectedColumns.includes(column.id)}
              onChange={() => handleToggle(column.id)}
              disabled={isLastEnabledColumn(column.id, staticColumns, selectedColumns)}
            />
          }
          label={
            <Typography variant="body2" color="textPrimary">
              {column.title}
            </Typography>
          }
        />
      </S.StaticColumnRow>
    ))}
  </Box>
)
